import { ChangeDetectionStrategy, Component, HostListener, inject, output } from "@angular/core";
import { DetectionService } from "../services/detection/detection.service";
import { DrawAreaPanelComponent } from "./panels/draw-area-panel/draw-area-panel.component";
import { ConfigurePanelComponent } from "./panels/configure-panel/configure-panel.component";
import { ResultsPanelComponent } from "./panels/results-panel/results-panel.component";
import { EmptyPanelComponent } from "./panels/empty-panel/empty-panel.component";

@Component({
  selector: "lib-custom-elements-panel",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex-fill d-block overflow-hidden' },
  imports: [DrawAreaPanelComponent, ConfigurePanelComponent, ResultsPanelComponent, EmptyPanelComponent],
  template: `
    <aside class="d-flex flex-column h-100 overflow-hidden">
      @switch (detection.stage()) {
        @case ('draw') { <lib-draw-area-panel (closeRequested)="closeRequested.emit()" /> }
        @case ('configure') { <lib-configure-panel /> }
        @case ('processing') { <lib-configure-panel [disabled]="true" /> }
        @case ('results') { <lib-results-panel /> }
        @case ('empty') { <lib-empty-panel /> }
      }
    </aside>
  `,
})
export class CustomElementsPanelComponent {
  readonly closeRequested = output<void>();

  protected readonly detection = inject(DetectionService);

  /** Debug: Alt+0 toggles the "merged fragments" overlay on the map and cards. */
  @HostListener("window:keydown", ["$event"])
  protected onKeyDown(event: KeyboardEvent): void {
    if (event.altKey && (event.key === "0" || event.code === "Digit0" || event.code === "Numpad0")) {
      event.preventDefault();
      this.detection.debugMergedVisible.update((v) => !v);
    }
  }
}
